import React from 'react'

export  function Order_status_componet(props) {
  return (
    <div className={props.className} >{props.text}</div>
  )
}
